export default __webpack_public_path__ + "static/media/icon_wallet.5c83ee94.svg";